import energyHouse from '~shared-assets/images/energy-house.svg';
import solarPanel from '~shared-assets/images/solar-panel.svg';
import solar from '~shared-assets/images/solar.svg';
import energyStation from '~shared-assets/images/energy-station.svg';
import heatPump from '~shared-assets/images/heat-pump-with-box.svg';
import boiler from '~shared-assets/images/boiler.svg';
import airConditioner from '~shared-assets/images/air-conditioner.svg';
import radiator from '~shared-assets/images/radiator.svg';

import { CSSProperties } from 'styled-components';

import { BodilColor } from '~src/branding';

type ImageProps = {
  width?: number | string;
  height?: number | string;
  color?: string;
  image?: string;
  style?: CSSProperties;
  onClick?: () => void;
  inline?: boolean;
};

const colorImageStyle = ({ width, height, image, color, style, inline }: ImageProps) => {
  return {
    width: width ?? (height ? undefined : '20px'),
    height: height ?? (width ? undefined : '20px'),
    aspectRatio: width && height ? undefined : `1 / 1`,
    background: color ?? BodilColor.base.default,
    WebkitMask: `url('${image}')`,
    maskImage: `url('${image}')`,
    WebkitMaskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    WebkitMaskSize: 'cover',
    maskSize: 'cover',
    display: inline ? 'inline-block' : undefined,
    ...style,
  };
};

export const EnergyHouse = (props: ImageProps) => <div style={colorImageStyle({ ...props, image: energyHouse })} />;

export const SolarPanel = (props: ImageProps) => <div style={colorImageStyle({ ...props, image: solarPanel })} />;

export const Solar = (props: ImageProps) => <div style={colorImageStyle({ ...props, image: solar })} />;

export const EnergyStation = (props: ImageProps) => <div style={colorImageStyle({ ...props, image: energyStation })} />;

export const HeatPumpWithBox = (props: ImageProps) => <div style={colorImageStyle({ ...props, image: heatPump })} />;

export const Boiler = (props: ImageProps) => <div style={colorImageStyle({ ...props, image: boiler })} />;

export const AirConditioner = (props: ImageProps) => (
  <div style={colorImageStyle({ ...props, image: airConditioner })} />
);

export const Radiator = (props: ImageProps) => <div style={colorImageStyle({ ...props, image: radiator })} />;
